import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import { colors } from "./Utils/Colors";
import config from "./config";
import './i18n';
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={colors}>
        <App config={config} />
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  console.error("El elemento con el ID 'root' no fue encontrado en el DOM.");
}
